import { render, staticRenderFns } from "./Vermicelli.vue?vue&type=template&id=335888ae&scoped=true"
import script from "./Vermicelli.vue?vue&type=script&lang=js"
export * from "./Vermicelli.vue?vue&type=script&lang=js"
import style0 from "./Vermicelli.vue?vue&type=style&index=0&id=335888ae&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "335888ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('335888ae')) {
      api.createRecord('335888ae', component.options)
    } else {
      api.reload('335888ae', component.options)
    }
    module.hot.accept("./Vermicelli.vue?vue&type=template&id=335888ae&scoped=true", function () {
      api.rerender('335888ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/member/userDetails/components/Vermicelli.vue"
export default component.exports